import { useGetLmsTrainingInstructorsQuery, useAddLmsTrainingInstructorMutation, useDeleteLmsTrainingInstructorMutation } from '../../../../api';
import toastService from '../../../../utils/toastService';
import { formatErrorMessage } from '../../../../utils/errorUtils';
import { useLanguage } from '../../../../contexts/LanguageContext';

/**
 * Eğitim detayındaki "Eğitmenler" sekmesi için veri hook'u.
 * Bkz. docs/LMS-Egitim-Katalogu-ve-Egitmenler-API 1.md §4.
 */
// Sorgu `skip` durumundayken (trainingId yok) her render'da yeni bir literal döndürmemek için
// modül seviyesinde sabit - aksi halde bu referansı bağımlılık dizisinde kullanan bileşenler
// (ör. training-planning/components/PlanningForm.jsx) gereksiz yere yeniden render/effect döngüsüne girebilir.
const EMPTY_LIST = { items: [], totalCount: 0 };

const useTrainingInstructorsData = (trainingId) => {
    const { th } = useLanguage();

    const {
        data: instructorsApi,
        isLoading,
        isFetching,
        refetch
    } = useGetLmsTrainingInstructorsQuery({ trainingId, pageNumber: 1, pageSize: 100 }, { skip: !trainingId, refetchOnMountOrArgChange: true });

    const [addMutation, { isLoading: isAdding }] = useAddLmsTrainingInstructorMutation();
    const [deleteMutation, { isLoading: isDeleting }] = useDeleteLmsTrainingInstructorMutation();

    const addInstructor = async (userId) => {
        try {
            await addMutation({ userId, trainingId }).unwrap();
            toastService.success(th('trainingCatalog.instructors.addSuccess'), th('common.success'));
            refetch();
            return true;
        } catch (err) {
            // 409: aynı eğitime aynı eğitmen ikinci kez atanmaya çalışılıyor
            if (err?.status === 409) {
                toastService.error(formatErrorMessage(err) || th('trainingCatalog.instructors.alreadyAssigned'), th('common.error'));
            } else {
                toastService.error(formatErrorMessage(err) || th('trainingCatalog.instructors.addError'), th('common.error'));
            }
            return false;
        }
    };

    const removeInstructor = async (id) => {
        try {
            await deleteMutation(id).unwrap();
            toastService.success(th('trainingCatalog.instructors.deleteSuccess'), th('common.success'));
            refetch();
            return true;
        } catch (err) {
            toastService.error(formatErrorMessage(err) || th('trainingCatalog.instructors.deleteError'), th('common.error'));
            return false;
        }
    };

    return {
        instructorsApi: instructorsApi || EMPTY_LIST,
        isLoading,
        isFetching,
        isAdding,
        isDeleting,
        addInstructor,
        removeInstructor,
        refetch
    };
};

export default useTrainingInstructorsData;
